import React from "react";

export default function ProjectsIcon({ className = "svg-98", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true" {...props}>
      <path
        d="M14.166 17.5L9.99935 14.1667L5.83268 17.5M5.66602 14.1667H14.3327C15.7328 14.1667 16.4329 14.1667 16.9677 13.8942C17.4381 13.6545 17.8205 13.272 18.0602 12.8016C18.3327 12.2669 18.3327 11.5668 18.3327 10.1667V6.5C18.3327 5.09987 18.3327 4.3998 18.0602 3.86502C17.8205 3.39462 17.4381 3.01217 16.9677 2.77248C16.4329 2.5 15.7328 2.5 14.3327 2.5H5.66602C4.26588 2.5 3.56582 2.5 3.03104 2.77248C2.56063 3.01217 2.17818 3.39462 1.9385 3.86502C1.66602 4.3998 1.66602 5.09987 1.66602 6.5V10.1667C1.66602 11.5668 1.66602 12.2669 1.9385 12.8016C2.17818 13.272 2.56063 13.6545 3.03104 13.8942C3.56582 14.1667 4.26588 14.1667 5.66602 14.1667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
